module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/photography-wideAngle-larger.a9d8fdac.jpg";